export const partner = 'PartnerAdmin';

export const admin = 'BusinessAdmin';

export const currentUserType =
  process.env.REACT_APP_APPLICATION === 'admin' ? admin : partner;
